import React from 'react'
import styles from './NotificationsPage.scss'
import {StandardLayout} from 'common/layouts/StandardLayout'
import {StandardWidthPage} from 'common/StandardWidthPage'
import {NotificationsApp} from 'features/notifications/NotificationsList'

export class NotificationsPage extends React.PureComponent {
  render () {
    return (
      <StandardLayout>
        <StandardWidthPage>
          <div className={styles.NotificationsPage}>
            <h1>All Notifications</h1>
            <div className={styles.list}>
              <NotificationsApp />
            </div>
          </div>
        </StandardWidthPage>
      </StandardLayout>
    )
  }
}
